<template>
	<transition name="slide-fade">
		<span>

			<div class="col-xs-12 grtit">
				<h2>PODCASTS</h2>
			</div>

			<div class="col-xs-12 podcasts" v-if="loaded === 'true'">
				<div class="col-xs-12 npd block podcast__item" v-for="programa in programas">


					<img v-if="programa.post_meta.thumb!=null" v-bind:src="programa.post_meta.thumb" alt="" class="podcasts__fondo">
					<img v-else v-bind:src="theme_url+'/html/assets/img/fondo__podcast.jpg'" alt="" class="podcasts__fondo">

					<div class="container">
						<div class="rgetProgramasow">
							<div class="player__playlist">
								<div class="compartir__player">
									<button><i class="icon share"></i></button>
									<ul>
										<li><a v-bind:href="'https://www.facebook.com/sharer/sharer.php?u='+programa.link" target="_blank"><i class="fa fa-facebook"></i></a></li>
										<li><a v-bind:href="'https://twitter.com/share?url='+programa.link+'&text='+programa.title.rendered" target="_blank"><i class="fa fa-twitter"></i></a></li>
										<li class="itemwa"><a v-bind:href="'whatsapp://send?text='+programa.link"><i class="fa fa-whatsapp"></i></a></li>
									</ul>
								</div>
								<a href="#" class="fav__player"><i v-bind:programa="programa.id" class="icon star"></i></a>
									<ul class="playlist">

										<li v-if="programa.better_featured_image!=null" v-bind:data-cover="programa.better_featured_image.media_details.sizes['536x412'].source_url" v-bind:data-descripcion="programa.soloexcerpt" class="col-xs-12 npd">

												<a v-if="programa.post_meta!=0" v-bind:href="programa.post_meta._enclosure_mp3">
													<span v-if="programa.post_meta!=0" class="titulo">{{ programa.post_meta.reciente.post_title }}</span>
													<span v-else class="titulo">{{ programa.title.rendered }}</span>
													<span class="autor">{{ programa.author_meta.display_name }}</span>
													<span class="fecha" v-if="programa.post_meta.fechaconformato !== undefined ">{{ programa.post_meta.fechaconformato }}</span>

													<span class="duracion">3:22</span>
												</a>
												<a v-else >
													<span  class="titulo">{{ programa.title.rendered }}</span>
													<span class="autor">{{ programa.author_meta.display_name }}</span>
													<span class="fecha" ></span>

													<span class="duracion">3:22</span>
												</a>
										
										<li v-else v-bind:data-cover="theme_url+'/html/assets/img/imgplay.jpg'" v-bind:data-descripcion="programa.soloexcerpt" class="col-xs-12 npd">

											<a v-bind:href="programa.post_meta_fields._enclosure_mp3">
												<span class="titulo">{{ programa.title.rendered }}</span>
												<span class="autor">{{ programa.author_meta.display_name }}</span>
												<span class="fecha" v-if="programa.fechaconformato !== undefined ">{{ programa.fechaconformato }}</span>

												<span class="duracion">3:22</span>
											</a>
										</li>
									</ul>
								<ul class="escuchar">
									<li><a href="#">ESCUCHAR  PODCAST RECIENTE</a></li>
									<li v-if="programa.post_meta.cat_programa!=null">

										<router-link :to="{ name: 'interna_podcast', params: { name:programa.post_meta.cat_programa.slug } }" >
											VER TODO
										</router-link>
									</li>
									<li v-else>
										<a href="#">VER TODO</a>
									</li>
								</ul> 
							</div>
						</div>
					</div>
				</div>

			</div>


			<section class="col-xs-12 block">
				<div class="container">
					<div class="row">

						<div class="col-xs-12 reflexiones__slid" v-if="loaded_posts === 'true'">

							<div class="reflexiones__item" v-for="podcast in posts">
							<!-- <a v-bind:href="podcast.link"> -->
							<router-link :to="{ name: 'post', params: { name:podcast.slug }}">

								<figure v-if="podcast.better_featured_image != null">
									<img v-bind:src="podcast.better_featured_image.media_details.sizes['536x412'].source_url" alt="">
								</figure>
								<figure v-else-if="podcast.featured_image_src['full'][0]">
									<img v-bind:src="podcast.featured_image_src['full'][0]" alt="">
								</figure>
								<figure v-else>
									<img v-bind:src="theme_url+'/html/assets/img/ref-slid.jpg'" alt="">
								</figure>
							<!-- </a> -->
							</router-link>
							<div class="reflexiones__title paused">
								<button class="reflexiones__player" v-bind:audio="podcast.post_meta_fields._enclosure_mp3">
									<i class="icon play-mini"></i>
								</button>
								<h3 v-html="podcast.title.rendered"></h3>
							</div>
							<div class="reflexiones__compartir compartir__player">
									<button>Compartir en <i class="icon share"></i></button>
									<ul>
										<li><a v-bind:href="'https://www.facebook.com/sharer/sharer.php?u='+podcast.link" target="_blank"><i class="fa fa-facebook"></i></a></li>
										<li><a v-bind:href="'https://twitter.com/share?url='+podcast.link+'&text='+podcast.title.rendered" target="_blank"><i class="fa fa-twitter"></i></a></li>
										<li class="itemwa"><a v-bind:href="'whatsapp://send?text='+podcast.link"><i class="fa fa-whatsapp"></i></a></li>
									</ul>
							</div>
						</div>
					</div>
				</div>
				</div>
			</section>

			<versiculosdeldia></versiculosdeldia>

		</span>
	</transition>
</template>

<script>
export default {
	mounted: function() {
		const vm = this;
		vm.getProgramas();
		//vm.getProgramasSticky();
		vm.getCatId( 'programa' );

	},
	data() {
		return {
			theme_url:rtwp.theme_url,
			programas: {},
			programas_sticky: {},
			loaded: 'false',
			loaded_sticky: 'false',
			posts: {},
			sticky: {},
			loaded_posts: 'false',
			pageTitle: '',
			totalCount: '',
			catName: '',
			LaCat: '',
			locutores:[],
			audios:{},
		};
	},
	methods: {
		getProgramas: function(  ) {
			const vm = this;
			vm.loaded = 'false';
			vm.$http.get( 'wp/v2/programas?per_page=99')
			.then( ( res ) => {
				vm.programas = res.data;
				vm.loaded = 'true';
				vm.$nextTick(function(){
					jQuery(".player__playlist").musicPlayer();
				});
				console.log(vm.programas);
				
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		},
		getProgramasSticky: function(  ) {
			const vm = this;
			vm.loaded_sticky = 'false';
			vm.$http.get( 'programas/sticky')
			.then( ( res ) => {
				vm.programas_sticky = res.data;
				vm.loaded_sticky = 'true';
				vm.$nextTick(function(){
					init_attach();
				});
				console.log(vm.programas_sticky);
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		},
		getPosts: function( catId ) {
			const vm = this;
			vm.loaded_posts = 'false';
			vm.$http.get( 'wp/v2/posts', {
				params: { categories: catId, sticky:false }
			} )
			.then( ( res ) => {
				vm.posts = res.data;
				vm.loaded_posts = 'true';
				vm.$nextTick(function(){
					activar_slick_reflexiones_portada();
					init_attach();
				});
				console.log('LEPOST');
				console.log(vm.posts);
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		},
		getSticky: function( catId ) {
			const vm = this;
			vm.loaded_sticky = 'false';
			vm.$http.get( 'wp/v2/posts', {
				params: { categories: catId, sticky:true }
			} )
			.then( ( res ) => {
				vm.sticky = res.data;
				vm.loaded_sticky = 'true';
				vm.$nextTick(function(){
					jQuery(".player__playlist").musicPlayer();
				});
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		},
		getCatId: function( name ) {
			const vm = this;
			console.log(name);
			vm.catName = name;
			vm.loaded = 'false';
			vm.$http.get( 'wp/v2/categories/?slug=' + name )
			.then( ( res ) => {
				vm.totalCount = (res.count);
				res = res.data[ 0 ];
				vm.catName=res.name;
				vm.pageTitle = vm.catName;
				vm.$store.commit( 'rtChangeTitle', vm.pageTitle );
				vm.getPosts( res.id );
				vm.getSticky( res.id );
				vm.LaCat=res;
				this.getCats(res.id);
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		},
		getCats:function (pid){
			// http://104.236.216.165/wp-json/wp/v2/categories/
			const vm = this;
			vm.loaded_categorias = 'false';
			vm.$http.get( 'wp/v2/categories/', {
				params: { hide_empty: true, parent:pid }
			} )
			.then( ( res ) => {
				vm.loaded_categorias='true';
				vm.categorias=res.data;
				vm.$nextTick(function(){
					jQuery("li[elpodcast='"+vm.LaCat.slug+"']").addClass('active');
				});
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		},
		getAudios: function( programaid ) {
			const vm = this;
			vm.loaded_audios = 'false';
			vm.$http.get( 'wp/v2/posts', {
				params: { elprograma: programaid, per_page:1,category:7 }
			} )
			.then( ( res ) => {
				vm.audios= res.data;
				// window._data=res.data;
				if(res.data.length>0){
					vm.loaded_audios = 'true';
				}
				vm.$nextTick(function(){
					jQuery(".player__playlist").musicPlayer();
					console.log(vm.audios);
				});
				
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		}
	}
};
</script>


// WEBPACK FOOTER //
// podcast.vue?4af7d7b4